import React from 'react'
import { Space, Button, notification, Modal, message as AntMessage } from 'antd'

import forge from 'node-forge'
import { Buffer } from 'buffer'
import conf from 'conf'
import exclamationIcon from 'assets/images/circle-blue-22.svg'
import { migrationClient, restLandingClient, clientForLanding } from 'myNet'
import store from 'store'
import i18n from 'i18n'

import { setEnvParam, setTempEnvParam, getTempEnvParam, removeTempEnvParam } from 'env'

import { history, store as reduxStore } from 'index'

import Ngql from 'gql/ninegql'

// import { stringToHash } from 'utils/ui'

import { ClientJS } from 'clientjs'

import { customFetch } from './services/jwt'

function strToBytes(str) {
  const bytes = new Uint8Array(str.length)
  for (let i = 0; i < str.length; i += 1) {
    const char = str.charCodeAt(i)
    bytes[i] = char
  }
  return bytes
}

export function sendEncrypted(apiName, params, successFunc, failFunc) {
  console.log(params)
  const publicKeyURL = '/provisioning/public_key/json'

  restLandingClient.get(publicKeyURL).then((res) => {
    const { version, publicKey } = res.data.data

    const api = `${conf.SERVER.restLandigURL}${apiName}${version}`

    const body0 = JSON.stringify(params)

    const body = forge.util.encodeUtf8(body0)

    console.log(' --- ', body, publicKey)

    let bytes = null

    // chat-test일 때는 encrypte 사용 안함.
    if (
      process.env.REACT_APP_TARGET !== 'log' &&
      conf.SERVER.restURL.indexOf('http://chat-test.rework.so:8001/v1') !== 0
    ) {
      const publicKeyObj = forge.pki.publicKeyFromPem(publicKey)

      const encrypted = publicKeyObj.encrypt(body, 'RSA-OAEP', {
        md: forge.md.sha256.create(),
        mgf1: {
          md: forge.md.sha256.create(),
        },
      })

      bytes = strToBytes(encrypted)
    } else {
      bytes = strToBytes(body)
    }

    const blob = new Blob([bytes], { type: 'application/octet-stream' })

    console.log(blob)

    // const token = store.get('app.user.token')
    // return the headers to the context so httpLink can read them

    const ret = customFetch(api, {
      method: 'POST',
      headers: {
        // authorization: `JWT ${token}`,
        // 'Content-Type': 'text/plain',
        // 'Content-Type': 'application/json',
        'content-type': 'application/x-www-form-urlencoded',
        // 'content-type': 'application/octet-stream',
      },
      body: blob,
    })

    ret
      .then((sres) => {
        console.log(' subscribe - ', sres)

        sres.json().then((data) => {
          console.log(' - ret : ', data)

          if (data.errors != null || data.code !== 200) {
            failFunc(data)
          } else if (successFunc != null) {
            successFunc(data)
          }
        })
      })
      .catch((error) => {
        failFunc(error)
      })
  })
}

export function getDeviceUUID(email) {
  let uuid = store.get('app.device.uuid')

  if (uuid == null) {
    const client = new ClientJS()
    const fingerprint = client.getFingerprint()
    const curTime = Date.now()

    const md = forge.md.md5.create()
    md.update(`${email}_${fingerprint}_${curTime}`)
    const hex = md.digest().toHex()
    uuid = `RW${hex}`
    store.set('app.device.uuid', uuid)
  }

  return uuid
}

export function updateAccountInfo(id, sendData, onUpdated, hideResultMsg) {
  const mutation = Ngql.Mutation('updateUserInfo', {
    updateUser: Ngql.Node(
      {
        ok: true,
        errors: true,
      },
      null,
      false,
      {
        userData: Ngql.Var('userData', 'updateUserInput'),
        userGid: Ngql.Var('userGid', 'String'),
      },
    ),
  })

  const variables = {
    userData: {
      // displayName: (displayName == null || displayName.length === 0) ? ' ' : displayName,
      // displayName,
      // avatarUrl,
      ...sendData,
    },
    // userGid: 'VXNlck5vZGU6MTk=',
  }

  if (id != null) {
    variables.userGid = id
  }

  Ngql.GQLObj(mutation, { vars: variables })
    .mutate({}, clientForLanding)
    .then((res) => {
      console.log(res)
      if (hideResultMsg !== true) {
        AntMessage.info(i18n.t('profile.result.modified'))
      }
      if (onUpdated != null) {
        onUpdated()
      }
      return true
    })
    .catch((error) => {
      console.log(error)
      notification.warning({
        message: error.code,
        description: error.message,
      })
    })
}

const webCryptoPbkdf2 = async (password, salt, numIterations, keySize) => {
  const keyMaterial = await window.crypto.subtle.importKey(
    'raw',
    Buffer.from(password, 'binary'),
    { name: 'PBKDF2' },
    false,
    ['deriveBits', 'deriveKey'],
  )
  const keyAsArrayBuffer = await window.crypto.subtle.deriveBits(
    {
      name: 'PBKDF2',
      salt: Buffer.from(salt, 'binary'),
      iterations: numIterations,
      hash: 'SHA-256',
    },
    keyMaterial,
    keySize << 3, // eslint-disable-line no-bitwise
  )

  const key = new forge.util.ByteBuffer(keyAsArrayBuffer).getBytes()
  console.log(' --- key : ', key)

  return key
}

async function generateKey(password, salt, numIterations, keySize) {
  const numIterations0 = numIterations || 100000
  const keySize0 = keySize || 32

  // const key = forge.pkcs5.pbkdf2(password, salt, numIterations0, keySize0, 'sha256')
  const key = await webCryptoPbkdf2(password, salt, numIterations0, keySize0)
  return key
}

function encryptAES(data, key) {
  const iv = forge.random.getBytesSync(16)

  // Note: a key size of 16 bytes will use AES-128, 24 => AES-192, 32 => AES-256
  const cipher = forge.cipher.createCipher('AES-CBC', key)
  cipher.start({ iv })
  const bytes = new forge.util.ByteBuffer(data)
  cipher.update(bytes)
  cipher.finish()

  const encrypted = cipher.output
  // console.log(encrypted.toHex());
  const encBytes = encrypted.getBytes()
  const ivBytes = forge.util.createBuffer(iv).getBytes()

  return ivBytes + encBytes
}

function decryptAES(ciphertext, key) {
  const ivStr = ciphertext.slice(0, 16) // IV 추출
  const iv = forge.util.createBuffer(ivStr)

  const decipher = forge.cipher.createDecipher('AES-CBC', key)
  decipher.start({ iv })
  const bytes = new forge.util.ByteBuffer(ciphertext.slice(16))
  decipher.update(bytes)
  decipher.finish()

  const decrypted = decipher.output
  const encBytes = decrypted.getBytes()

  return encBytes
}

export async function encryptAESByKey(data, key, numIterations) {
  const salt = forge.random.getBytesSync(16)
  const enKey = await generateKey(key, salt, numIterations)
  const encryptedBytes = encryptAES(data, enKey)
  return salt + encryptedBytes
}

export async function decryptAESByKey(ciphertext, key, numIterations) {
  const salt = ciphertext.slice(0, 16) // IV 추출

  const enKey = await generateKey(key, salt, numIterations)
  const decryptedBytes = decryptAES(ciphertext.slice(16), enKey)

  return decryptedBytes
}

const UMKInfo = {
  useTempEnv: process.env.REACT_APP_TARGET === 'production',
  mouseMoveTimer: null,
  mouseMoveCnt: 0,
}

// if (process.env.REACT_APP_TARGET === 'production') {
//   UMKInfo.useTempEnv = true
// }

if (UMKInfo.useTempEnv === true) {
  UMKInfo.set = (key, value) => {
    setTempEnvParam(key, value)
  }
  UMKInfo.get = (key) => {
    return getTempEnvParam(key)
  }
  UMKInfo.remove = (key) => {
    removeTempEnvParam(key)
  }
} else {
  UMKInfo.set = (key, value) => {
    store.set(key, value)
  }
  UMKInfo.get = (key) => {
    return store.get(key)
  }
  UMKInfo.remove = (key) => {
    store.remove(key)
  }
}

export function setUMKOptions(options) {
  if (UMKInfo.opts == null) {
    UMKInfo.opts = {
      loopTime: 30 * 1000, // 30초마다 체크.
      duration: 10 * 60 * 1000, // 10분 동안 유효.
      warningDuration: 1 * 60 * 1000, // 만료 전에 경고창 표시 시간.
      expiredMsg: 'UMK expired',
      warningMsg: 'UMK will be expired in 1 minute',
    }
  }

  UMKInfo.opts = {
    ...UMKInfo.opts,
    ...options,
  }
}

// function saveUMKData() {
// }
function saveUMKData(UMK, expireTime) {
  const umkData = {
    UMK,
    expireTime,
  }
  const umkDataStr = JSON.stringify(umkData)

  if (process.env.REACT_APP_TARGET === 'production') {
    const reduxState = reduxStore.getState()
    const { email } = reduxState.user
    encryptAESByKey(umkDataStr, email, 10000).then((encData) => {
      UMKInfo.set('app.user.encUMK', encData)
    })
  } else {
    UMKInfo.set('app.user.encUMK', umkDataStr)
  }
}

export function setUMKToLocal(UMK, options) {
  setUMKOptions(options)

  UMKInfo.startCheck = () => {
    if (UMKInfo.checkExpiredTimer != null) {
      clearTimeout(UMKInfo.checkExpiredTimer)
    }

    const { duration, warningDuration, loopTime } = UMKInfo.opts

    UMKInfo.warningOpened = false
    UMKInfo.expiredTime = Date.now() + duration
    UMKInfo.warningTime = warningDuration > 0 ? Date.now() + duration - warningDuration : 0

    saveUMKData(UMK, UMKInfo.expiredTime)

    UMKInfo.checkExpired = () => {
      const { expiredTime, warningTime } = UMKInfo
      const curTime = Date.now()

      console.log(' --- remain time : ', (expiredTime - curTime) / 1000)

      let nextInterval = 0
      if (warningTime > 0 && expiredTime > warningTime) {
        if (curTime < warningTime) {
          nextInterval = warningTime - curTime
        } else if (curTime < expiredTime) {
          nextInterval = expiredTime - curTime
        }
      } else if (curTime < expiredTime) {
        nextInterval = expiredTime - curTime
      }

      if (nextInterval > 0) {
        nextInterval = Math.min(nextInterval, loopTime)
        nextInterval = Math.max(nextInterval, 1000)

        if (
          warningTime > 0 &&
          curTime >= warningTime &&
          curTime < expiredTime &&
          UMKInfo.warningOpened !== true
        ) {
          const time = (expiredTime - curTime) / 1000
          console.log(' --- warning', time)

          const key = `open${Date.now()}`
          const btn = (
            <Space>
              <Button
                type="primary"
                size="small"
                onClick={() => {
                  UMKInfo.startCheck()
                  notification.destroy(key)
                }}
              >
                Extend time
              </Button>
            </Space>
          )
          notification.open({
            key,
            message: 'Warning',
            description: UMKInfo.opts.warningMsg,
            btn,
            showProgress: true,
            duration: time,
          })
          UMKInfo.warningOpened = true
        }

        UMKInfo.checkExpiredTimer = setTimeout(() => {
          UMKInfo.checkExpired()
        }, nextInterval)
      } else {
        Modal.destroyAll()
        const curPath = window.location.pathname

        // 만료 시간이 지났음.
        notification.warning({
          icon: <img src={exclamationIcon} alt="exclamation" />,
          message: i18n.t('common.warning.securityLock'),
          description: i18n.t('common.warning.securityLockMsg'),
        })
        deleteUMKFromLocal()

        const pureLoginPath = '/migration'
        const loginPath = `/migration?path=${curPath}`
        if (curPath === pureLoginPath) {
          history.push(pureLoginPath)
          window.addEventListener('popstate', () => {
            history.push(pureLoginPath)
          })
        } else {
          history.push(loginPath)
          window.addEventListener('popstate', () => {
            history.push(loginPath)
          })
        }
      }
    }

    if (duration > 0) {
      UMKInfo.checkExpired()
    }
  }

  UMKInfo.startCheck()
}

export function notifyMouseMove() {
  if (UMKInfo.warningOpened !== true && UMKInfo.checkExpiredTimer != null) {
    if (UMKInfo.mouseMoveTimer == null) {
      console.log(' --- notifyMouseMove', UMKInfo.warningOpened)
      console.log(' --- startCheck')
      if (UMKInfo.startCheck != null) {
        UMKInfo.startCheck()
      }
      UMKInfo.mouseMoveCnt = 0
      // 30초 마다 한번만 timer reset.
      UMKInfo.mouseMoveTimer = setTimeout(() => {
        UMKInfo.mouseMoveTimer = null
        if (UMKInfo.mouseMoveCnt > 0) {
          console.log(' --- startCheck2')
          UMKInfo.mouseMoveTimer = null
          if (UMKInfo.startCheck != null) {
            UMKInfo.startCheck()
          }
        }
      }, 30000)
    } else {
      UMKInfo.mouseMoveCnt += 1
    }
  }
}

export function deleteUMKFromLocal() {
  if (UMKInfo.mouseMoveTimer != null) {
    clearTimeout(UMKInfo.mouseMoveTimer)
    UMKInfo.mouseMoveTimer = null
  }
  if (UMKInfo.checkExpiredTimer != null) {
    clearTimeout(UMKInfo.checkExpiredTimer)
    UMKInfo.checkExpiredTimer = null
  }
  UMKInfo.remove('app.user.encUMK')
}

export async function getUMKFromLocal(resetExpireTimer) {
  const encUMKData = UMKInfo.get('app.user.encUMK')

  if (encUMKData == null) {
    return null
  }

  let umkDataStr = null
  if (process.env.REACT_APP_TARGET === 'production') {
    const reduxState = reduxStore.getState()
    const { email } = reduxState.user
    umkDataStr = await decryptAESByKey(encUMKData, email, 10000)
  } else {
    umkDataStr = encUMKData
  }

  const umkData = JSON.parse(umkDataStr)

  const { UMK, expireTime } = umkData

  if (expireTime < Date.now()) {
    deleteUMKFromLocal()
    return null
  }

  if (resetExpireTimer === true && UMKInfo.startCheck != null) {
    UMKInfo.startCheck()
  }

  return UMK
}

export function hashString(str) {
  const md = forge.md.sha256.create()
  md.update(str)
  return md.digest().toHex()
}

export function RSAEncDec(options) {
  forge.options.usePureJavaScript = false
  console.log(' ---- forge option : ', forge.options)

  const self = this

  if (options == null) {
    throw new Error('options is empty.')
  }

  self.keySize = 4096 // 키 사이즈 설정 (2048비트)
  self.maxMessageLength = 446 // RSA로 암호화할 수 있는 최대 메시지 길이 (키 사이즈에 따라 다름)

  // password 초기화.
  const initUMK = async () => {
    if (options.umk != null) {
      self.umk = options.umk
    } else {
      self.umk = await getUMKFromLocal()
    }

    if (self.umk == null) {
      throw new Error('UMK not found')
    }
  }

  self.UMK = () => {
    return self.umk
  }

  if (options.isGroup === true) {
    self.getGroupKey = () => {
      return self.umk
    }
  }

  self.UMKHash = () => {
    return hashString(self.UMK())
  }

  self.clear = () => {
    self.umk = null
    self.publicKeyPem = null
    self.privateKeyPem = null
  }

  self.publicKeyPem = null
  self.privateKeyPem = null

  // 공개 키와 비밀 키 생성
  const generateRSAKey = () => {
    return new Promise((resolve, reject) => {
      forge.pki.rsa.generateKeyPair({ bits: self.keySize, workers: 2 }, (err, keypair) => {
        if (err) {
          reject(err)
        } else {
          const publicKeyPem = forge.pki.publicKeyToPem(keypair.publicKey) // 공개 키 PEM 형식으로 변환
          const privateKeyPem = forge.pki.privateKeyToPem(keypair.privateKey) // 비밀 키 PEM 형식으로 변환
          resolve({ publicKeyPem, privateKeyPem })
        }
      })
    })
  }

  const oaepOpts = {
    md: forge.md.sha256.create(),
    mgf1: forge.mgf1.create(forge.md.sha256.create()),
  }

  // 공개 키를 사용해 메시지 암호화
  const encryptToBase64 = (message) => {
    const publicKey = forge.pki.publicKeyFromPem(self.publicKeyPem) // PEM 형식의 공개 키 불러오기
    const encrypted = publicKey.encrypt(message, 'RSA-OAEP', oaepOpts)
    return forge.util.encode64(encrypted) // Base64로 인코딩하여 반환
  }

  // 비밀 키를 사용해 메시지 복호화
  const decryptFromBase64 = (encryptedMessageBase64) => {
    const encryptedBytes = forge.util.decode64(encryptedMessageBase64) // Base64 디코딩
    const privateKey = forge.pki.privateKeyFromPem(self.privateKeyPem) // PEM 형식의 비밀 키 불러오기
    const decrypted = privateKey.decrypt(encryptedBytes, 'RSA-OAEP', oaepOpts)
    return decrypted
  }

  self.init = async () => {
    await initUMK()

    let ret = null
    if (options.isRegister === true) {
      ret = await self.register()
    } else if (options.isLogin === true) {
      ret = await self.login()
    } else if (options.isGroup === true) {
      ret = await self.registerGroup()
    }
    // else if (options.isChangePW === true) {
    //   ret = await self.changePW(options.newPassword);
    // }
    return ret
  }

  const sendSafeboxData = (safeboxData) => {
    const { user_id: userId, role, user_email: email, user_name: name } = safeboxData

    const safebox = {
      userId,
      role,
      email,
      name,
    }

    setEnvParam('appType', JSON.stringify(safebox))

    reduxStore.dispatch({
      type: 'user/SET_STATE',
      payload: {
        safebox,
      },
    })
  }

  self.login = async () => {
    const reduxState = reduxStore.getState()
    const { email } = reduxState.user

    const params = {
      fingerprint: hashString(email), // 임시로 email을 해싱하여 fingerprint로 사용.
      hmk: self.UMKHash(),
    }

    try {
      const umkRes = await migrationClient.post(`/v1/auth/login`, params)
      const { code, data } = umkRes.data
      console.log('umkInfo - ', code, data)
      if (code === 200) {
        const { role, user_id: userId, user_public_key: userPublicKey, user_key: userKey } = data
        sendSafeboxData(data)
        console.log('umkInfo - ', role, userId, userPublicKey, userKey)

        self.publicKeyPem = userPublicKey

        const decPrivateKey = forge.util.decode64(userKey)
        self.privateKeyPem = await decryptAESByKey(decPrivateKey, this.UMK())

        const saveOptions = {}
        if (options.duration != null) {
          saveOptions.duration = options.duration
        }
        if (options.warningDuration != null) {
          saveOptions.warningDuration = options.warningDuration
        }
        setUMKToLocal(self.UMK(), saveOptions)
        return Promise.resolve(true)
      }
    } catch (e) {
      console.log(' - umkLogin error : ', e)
      throw e
    }

    return Promise.resolve(false)
  }

  self.register = async () => {
    const { publicKeyPem, privateKeyPem } = await generateRSAKey()

    self.publicKeyPem = publicKeyPem
    self.privateKeyPem = privateKeyPem

    const reduxState = reduxStore.getState()
    const { email, name } = reduxState.user

    const encPrivateKey = await encryptAESByKey(self.privateKeyPem, self.UMK())

    const params = {
      user: {
        user_email: email,
        fingerprint: hashString(email), // 임시로 email을 해싱하여 fingerprint로 사용.
        hmk: self.UMKHash(),
      },
      user_key: {
        public_key: self.publicKeyPem,
        key: forge.util.encode64(encPrivateKey), // BASE64 Encrypted User Private Key (RSA)
      },
      user_profile: {
        first_name: '',
        last_name: name,
      },
    }

    try {
      const umkRes = await migrationClient.post(`/v1/auth/register`, params)
      const { code, data, message } = umkRes.data
      console.log('umkInfo - ', code, data)
      if (code === 200) {
        sendSafeboxData(data)
        const saveOptions = {}
        if (options.duration != null) {
          saveOptions.duration = options.duration
        }
        if (options.warningDuration != null) {
          saveOptions.warningDuration = options.warningDuration
        }
        setUMKToLocal(self.UMK(), saveOptions)
        return Promise.resolve(true)
      }

      const err = new Error(message)
      err.code = code
      return Promise.reject(err)
    } catch (e) {
      console.log(' - umkRegister error : ', e)
    }

    return Promise.resolve(false)
  }

  self.changePW = async (newPassword, selfInit) => {
    if (selfInit === true) {
      await initUMK()
    }

    const reduxState = reduxStore.getState()
    const { email } = reduxState.user

    if (options.base64PrivateKey != null) {
      const decPrivateKey = forge.util.decode64(options.base64PrivateKey)
      self.privateKeyPem = await decryptAESByKey(decPrivateKey, this.UMK())
    }

    const encPrivateKey = await encryptAESByKey(self.privateKeyPem, newPassword)

    const params = {
      fingerprint: hashString(email), // 임시로 email을 해싱하여 fingerprint로 사용.
      old_hmk: self.UMKHash(),
      new_hmk: hashString(newPassword),
      new_enc_priv: forge.util.encode64(encPrivateKey),
    }

    try {
      const umkRes = await migrationClient.put(`/v1/auth/change-password`, params)
      const { code, data } = umkRes.data
      console.log('umkInfo - ', code, data)
      if (code === 200) {
        const { role, user_id: userId, user_public_key: userPublicKey, user_key: userKey } = data
        sendSafeboxData(data)

        console.log('umkInfo - ', role, userId, userPublicKey, userKey)

        self.umk = newPassword
        self.publicKeyPem = userPublicKey

        const decPrivateKey = forge.util.decode64(userKey)
        self.privateKeyPem = await decryptAESByKey(decPrivateKey, this.UMK())

        const saveOptions = {}
        if (options.duration != null) {
          saveOptions.duration = options.duration
        }
        if (options.warningDuration != null) {
          saveOptions.warningDuration = options.warningDuration
        }
        setUMKToLocal(self.UMK(), saveOptions)
        return Promise.resolve(true)
      }
    } catch (e) {
      console.log(' - umkChangePW error : ', e)
    }

    return Promise.resolve(false)
  }

  self.registerGroup = async () => {
    const { publicKeyPem, privateKeyPem } = await generateRSAKey()

    self.publicKeyPem = publicKeyPem
    self.privateKeyPem = privateKeyPem

    const encPrivateKey = await encryptAESByKey(self.privateKeyPem, self.UMK())

    const params = {
      name: options.name,
      public_key: self.publicKeyPem,
      enc_private_key: forge.util.encode64(encPrivateKey), // BASE64 Encrypted Group Private Key (RSA)
      enc_group_key: options.encGroupKey,
    }

    try {
      const umkRes = await migrationClient.post(`/v1/admin/groups`, params)
      const { code, data } = umkRes.data
      console.log('create group - ', code, data)
      if (code === 200) {
        self.groupId = data.group_id
        return Promise.resolve(true, umkRes)
      }
      const errMsg = umkRes.data.message
      const err = new Error(errMsg)
      err.code = code
      return Promise.reject(err)
    } catch (e) {
      return Promise.reject(new Error(e))
    }
  }

  self.setGroupInfo = async (groupInfo) => {
    await initUMK()

    const {
      id: groupId,
      groupKey,
      public_key: groupPublicKey,
      enc_private_key: encPrivateKey,
    } = groupInfo

    self.groupId = groupId

    self.umk = groupKey
    self.publicKeyPem = groupPublicKey

    if (encPrivateKey != null) {
      const decPrivateKey = forge.util.decode64(encPrivateKey)
      self.privateKeyPem = await decryptAESByKey(decPrivateKey, this.UMK())
    }

    return Promise.resolve(true)
  }

  // this.saveRSAKey = () => {
  // api로 저장하도록 수정 필요.
  // const encPrivateKey = await encryptAESByKey(this.privateKeyPem, this.UMK());
  // const encPublicKey = await encryptAESByKey(this.publicKeyPem, this.UMK());
  // store.set('app.user.encPrivateKey', encPrivateKey);
  // store.set('app.user.encPublicKey', encPublicKey);
  // }

  // self.loadRSAKey = () => {
  //   // api로 저장하도록 수정 필요.
  //   const encPrivateKey = store.get('app.user.encPrivateKey');
  //   const encPublicKey = store.get('app.user.encPublicKey');
  //   if (encPrivateKey == null || encPublicKey == null) {
  //     throw new Error('RSA key not found');
  //   }
  //   self.privateKeyPem = await decryptAESByKey(encPrivateKey, this.UMK());
  //   self.publicKeyPem = await decryptAESByKey(encPublicKey, this.UMK());
  // }
  const createRsKey = () => {
    return forge.random.getBytesSync(32)
  }

  self.createRSKeyObj = (curEncRsKey) => {
    let rsKey = null
    let encRsKey = null

    if (curEncRsKey == null) {
      rsKey = createRsKey()
      encRsKey = encryptToBase64(rsKey)
    } else {
      encRsKey = curEncRsKey
      rsKey = decryptFromBase64(encRsKey)
    }

    const rsKeyObj = {
      rsKey,
      encRsKey,
      getEncRsKey: () => {
        return rsKeyObj.encRsKey
      },
      encrypt: async (resource) => {
        const utf8res = forge.util.encodeUtf8(resource)
        const encResouceBytes = await encryptAESByKey(utf8res, rsKeyObj.rsKey)
        const encResouce = forge.util.encode64(encResouceBytes)
        return encResouce
      },
      decrypt: async (encResouce) => {
        const encResouceBytes = forge.util.decode64(encResouce)
        const resource = await decryptAESByKey(encResouceBytes, rsKeyObj.rsKey)
        const decUtf8res = forge.util.decodeUtf8(resource)
        return decUtf8res
      },
      encryptBytes: async (resource) => {
        const encResouceBytes = await encryptAESByKey(resource, rsKeyObj.rsKey)
        return encResouceBytes
      },
      decryptBytes: async (encResouceBytes) => {
        const resource = await decryptAESByKey(encResouceBytes, rsKeyObj.rsKey)
        return resource
      },
      md5: (resource) => {
        const md = forge.md.md5.create()
        md.update(resource)
        return md.digest().toHex()
      },
      getEncRsKeyForShare: (targetPublicKeyPem) => {
        const publicKey = forge.pki.publicKeyFromPem(targetPublicKeyPem) // PEM 형식의 공개 키 불러오기
        const encrypted = publicKey.encrypt(rsKeyObj.rsKey, 'RSA-OAEP', oaepOpts)
        return forge.util.encode64(encrypted) // Base64로 인코딩하여 반환
      },
    }

    return rsKeyObj
  }

  self.createGroupObj = async (name) => {
    const groupKey = createRsKey()

    const encGroupKey = encryptToBase64(groupKey)

    const groupOptions = {
      name,
      umk: groupKey,
      isGroup: true,
      encGroupKey,
    }

    const groupRsaObj = new RSAEncDec(groupOptions)
    await groupRsaObj.init()

    return groupRsaObj
  }

  self.getGroupObj = async (groupInfo) => {
    const { enc_group_key: encGroupKey } = groupInfo
    const groupKey = decryptFromBase64(encGroupKey)

    const gInfo = {
      id: groupInfo.id,
      public_key: groupInfo.public_key,
      enc_private_key: groupInfo.enc_private_key,
      name: groupInfo.name,
      groupKey,
    }

    const groupRsaObj = new RSAEncDec({ isGroup: true })
    await groupRsaObj.setGroupInfo(gInfo)

    return groupRsaObj
  }

  self.getEncUserGroupKeyForAdd = (userPublicKeyPem) => {
    const publicKey = forge.pki.publicKeyFromPem(userPublicKeyPem) // PEM 형식의 공개 키 불러오기
    const groupKey = self.getGroupKey()
    const encrypted = publicKey.encrypt(groupKey, 'RSA-OAEP', oaepOpts)
    return forge.util.encode64(encrypted) // Base64로 인코딩하여 반환
  }

  self.encryptResourceOnce = async (resource) => {
    const rsKey = forge.random.getBytesSync(32)

    const encResouceBytes = await encryptAESByKey(resource, rsKey)
    const encResouce = forge.util.encode64(encResouceBytes)
    const encRsKey = encryptToBase64(rsKey)

    return {
      encResouce,
      encRsKey,
    }
  }

  self.decryptResourceOnce = async (resInfo) => {
    const { encResouce, encRsKey } = resInfo
    const rsKey = decryptFromBase64(encRsKey)
    const encResouceBytes = forge.util.decode64(encResouce)
    const resource = await decryptAESByKey(encResouceBytes, rsKey)

    return resource
  }
}

const pUtils = {
  sendEncrypted,
  getDeviceUUID,
}

export default pUtils
